import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import MasterDataSevices from '../../services/masterDataServices';
import { clearAuth } from 'store/auth';

export const getHarga = createAsyncThunk(
  'master/harga',
  async ({ student_type_id, subscription_type_id, class_type_id, school_type_id, tahun_ajaran_id, jenjang_id, cabang_id }, thunkAPI) => {
    try {
      const response = await MasterDataSevices.harga(
        student_type_id,
        subscription_type_id,
        class_type_id,
        school_type_id,
        tahun_ajaran_id,
        jenjang_id,
        cabang_id
      );
      return response.data;
    } catch (error) {
      if (error.response.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getStudent = createAsyncThunk(
  'master/studentList',
  async ({ page, perPage, sort, orderBy, search, jenjang_id, sekolah_id }, thunkAPI) => {
    try {
      const response = await MasterDataSevices.student(page, perPage, sort, orderBy, search, jenjang_id, sekolah_id);
      return response.data;
    } catch (error) {
      if (error.response.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getStudentByMapel = createAsyncThunk(
  'master/studentByMapel',
  async (
    { mapelId, cabang = null, classType = null, page = null, perPage = null, sort = null, orderBy = null, search = null },
    thunkAPI
  ) => {
    try {
      const response = await MasterDataSevices.studentByMapel(mapelId, cabang, classType, page, perPage, sort, orderBy, search);
      return response.data;
    } catch (error) {
      if (error.response.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getUser = createAsyncThunk('master/user', async (data, thunkAPI) => {
  try {
    const response = await MasterDataSevices.user(data?.type, data?.page, data?.perPage, data?.sort, data?.orderBy, data?.search);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response);
  }
});

export const getTahunAjaran = createAsyncThunk('master/tahunajaran', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.tahunajaran();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getSekolah = createAsyncThunk('master/sekolah', async (jenjang, thunkAPI) => {
  try {
    const response = await MasterDataSevices.sekolah(jenjang);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getCabang = createAsyncThunk('master/cabang', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.cabang();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getJenjang = createAsyncThunk('master/jenjang', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.jenjang();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getMapel = createAsyncThunk('master/mapel', async (jenjangID, thunkAPI) => {
  try {
    const response = await MasterDataSevices.mapel(jenjangID);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getBab = createAsyncThunk('master/bab', async (mapelID, thunkAPI) => {
  try {
    const response = await MasterDataSevices.bab(mapelID);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getSubbab = createAsyncThunk('master/subbab', async (babID, thunkAPI) => {
  try {
    const response = await MasterDataSevices.subbab(babID);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getStudentType = createAsyncThunk('master/student', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.studentType();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getSubscriptionType = createAsyncThunk('master/subscription', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.subscriptionType();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getClassType = createAsyncThunk('master/class', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.classType();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getSchoolType = createAsyncThunk('master/school', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.schoolType();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getExamType = createAsyncThunk('master/exam', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.examType();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getMasterFilter = createAsyncThunk('master/filter', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.masterFilter();

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getBase64File = createAsyncThunk('master/base62', async (data, thunkAPI) => {
  try {
    const response = await MasterDataSevices.getBase64File(data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getWeekDay = createAsyncThunk('master/weekday', async (_, thunkAPI) => {
  try {
    const response = await MasterDataSevices.getWeekDay();
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = {
  isLoading: true,
  harga: [],
  user: [],
  studentList: [],
  tahunajaran: [],
  sekolah: [],
  cabang: [],
  jenjang: [],
  mapel: [],
  studentByMapel: [],
  bab: [],
  subbab: [],
  student: [],
  subscription: [],
  class: [],
  school: [],
  exam: [],
  file: null,
  weekday: []
};

const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {
    setMapels: (state, action) => {
      return {
        ...state,
        mapel: action.payload
      };
    },
    clearMapels: (state) => {
      return {
        ...state,
        mapel: []
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getMasterFilter.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getMasterFilter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tahunajaran = action.payload?.tahun;
        state.cabang = action.payload?.cabang;
        state.jenjang = action.payload?.jenjang;
        state.student = action.payload?.student;
        state.subscription = action.payload?.subscription;
        state.class = action.payload?.class;
        state.school = action.payload?.school;
      }),
      builder.addCase(getMasterFilter.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getHarga.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getHarga.fulfilled, (state, action) => {
        state.isLoading = false;
        state.harga = action.payload;
      }),
      builder.addCase(getHarga.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getUser.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      }),
      builder.addCase(getUser.rejected, (state, action) => {
        state.isLoading = false;
        console.log(action);
      }),
      builder.addCase(getStudent.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.studentList = action.payload;
      }),
      builder.addCase(getStudent.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getTahunAjaran.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getTahunAjaran.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tahunajaran = action.payload;
      }),
      builder.addCase(getTahunAjaran.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSekolah.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getSekolah.fulfilled, (state, action) => {
        state.isLoading = false;
        state.sekolah = action.payload;
      }),
      builder.addCase(getSekolah.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getCabang.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getCabang.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cabang = action.payload;
      }),
      builder.addCase(getCabang.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getJenjang.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getJenjang.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jenjang = action.payload;
      }),
      builder.addCase(getJenjang.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getMapel.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getMapel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mapel = action.payload;
      }),
      builder.addCase(getMapel.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getBab.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getBab.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bab = action.payload;
      }),
      builder.addCase(getBab.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSubbab.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getSubbab.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subbab = action.payload;
      }),
      builder.addCase(getSubbab.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getStudentType.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getStudentType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.student = action.payload;
      }),
      builder.addCase(getStudentType.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSubscriptionType.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getSubscriptionType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscription = action.payload;
      }),
      builder.addCase(getSubscriptionType.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getClassType.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getClassType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.class = action.payload;
      }),
      builder.addCase(getClassType.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSchoolType.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getSchoolType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.school = action.payload;
      }),
      builder.addCase(getSchoolType.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getExamType.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getExamType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.exam = action.payload;
      }),
      builder.addCase(getExamType.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getBase64File.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getBase64File.fulfilled, (state, action) => {
        state.isLoading = false;
        state.file = action.payload;
      }),
      builder.addCase(getBase64File.rejected, (state) => {
        state.isLoading = false;
      });
    builder.addCase(getStudentByMapel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getStudentByMapel.fulfilled, (state, action) => {
      state.isLoading = false;
      state.studentList = action.payload;
    });
    builder.addCase(getStudentByMapel.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getWeekDay.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getWeekDay.fulfilled, (state, action) => {
      state.isLoading = false;
      state.weekday = action.payload;
    });
    builder.addCase(getWeekDay.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

const { reducer, actions } = masterSlice;
export const { setMapels, clearMapels } = actions;
export default reducer;
